<template>
  <div class="index">
    <div class="index-con">
      <div class="info-top">
        <div class="index-title">Conference info</div>
        <div class="info-small-title">
          <span>·</span>
          23rd International Drying Symposium (IDS 2024)
        </div>
        <div class="info-text">
          <span>·</span> <b>Conference Date:</b> November 22-25, 2024
        </div>
        <div class="info-text">
          <span>·</span> <b>Venue:</b> Worldhotel Grand Juna Wuxi, Wuxi, China
        </div>
      </div>
      <div class="login-con">
        <div class="index-title">Log in</div>
        <div class="login-cons">
          <div class="login-tip">System timeout . You need to log in again</div>
          <div class="login-list">
            <p class="login-title">Email:</p>
            <input type="text" v-model="username" />
          </div>
          <div class="login-list">
            <p class="login-title">Password:</p>
            <input type="password" v-model="password" />
          </div>
          <div class="login-btn" @click="toLoginThen">Log in</div>
          <div class="login-text" @click="toSimpleReg">
            No account number yet?
            <span class="text-blue">Create an account</span>
          </div>
          <!-- <p class="text-blue">I forgot password</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  methods: {
    toSimpleReg() {
      this.$router.push("/simpleReg");
    },
    toLoginThen() {
      // this.$router.push("/loginThen")
      if (!this.username) {
        this.$message.error("Please enter your email address");
        return;
      }
      if (!this.password) {
        this.$message.error("Please enter your Password");
        return;
      }
      var params = {
        username: this.username,
        password: this.password,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.login(params).then((res) => {
        console.log(res);
        loading.close();
        if (res.code == "200") {
          that.$message.success("Login successful");
          var con = res.data;
          localStorage.setItem("Firstname", con.Firstname);
          localStorage.setItem("Lastname", con.Lastname);
          localStorage.setItem("email", con.email);
          localStorage.setItem("mytitle", con.mytitle);
          localStorage.setItem("token", con.token);
          localStorage.setItem("visitor_id", con.visitor_id);
          setTimeout(() => {
            that.$router.push("/loginThen");
          }, 500);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
}

.login-con {
  margin-top: 20px;
}

.index-title {
  font-size: 18px;
  font-weight: 500;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.info-top {
  margin-top: 40px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding-bottom: 20px;
}

.info-small-title {
  padding-top: 10px;
  text-indent: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
}

.info-small-title span,
.info-text span {
  font-weight: 800;
  font-size: 20px;
}

.info-text {
  text-indent: 20px;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}

.login-con {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 30px;
}

.login-cons {
  padding: 20px;
  box-sizing: border-box;
}

.login-tip {
  font-weight: 600;
  color: #8a6d3b;
  background-color: #fcf8e3;
  border: 1px solid #faebcc;
  text-indent: 20px;
  height: 55px;
  line-height: 55px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.login-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.login-list {
  margin-bottom: 20px;
}

.login-list input {
  width: 50%;
  color: #555;
  height: 42px;
  padding-left: 20px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.login-btn {
  color: #fff;
  background-color: #428bca;
  border: 1px solid #357ebd;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 15px;
  display: inline-block;
}

.login-text {
  margin-bottom: 15px;
}

.text-blue {
  color: #428bca;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .login-tip {
    font-size: 14px;
    text-indent: 10px;
  }

  .login-list input {
    width: 100%;
  }

  .info-small-title {
    height: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue